import React, { useState, useEffect } from "react";
import { Plus, Search, Trash2, Edit2, Printer } from "lucide-react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import ApiUrl from "../Environment/ApiUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const ProductsTable = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [privileges, setPrivileges] = useState(null);

  useEffect(() => {
    const getaccess = localStorage.getItem("role");
    setPrivileges(getaccess);
  }, []);



  // Form validation states
  const [errors, setErrors] = useState({
    Category: "",
    Subcategory: "",
    brand_name: "",
  });

  const [updateErrors, setUpdateErrors] = useState({
    Category: "",
    Subcategory: "",
  });

  // Open and close modal functions
  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setErrors({
      Category: "",
      Subcategory: "",
      brand_name: "",
    });
  };

  useEffect(() => {
    fetchdata();
    addcategory();
  }, []);

  const [productData, setProductData] = useState({
    HSN_code: "",
    Category: "",
    Subcategory: "",
    brand_name: "",
    type: "",
    tyre_size: "",
    status: "Active",
  });

  const [producttabledata, setProducttabledata] = useState([]);
  const [categorytabledata, setCategorytabledata] = useState([]);

  const fetchdata = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${ApiUrl}/product_data.php`);
      if (response.data && response.data.data) {
        setProducttabledata(response.data.data);
      } else {
        setProducttabledata([]);
      }
    } catch (error) {
      console.log("error is fetching", error);
      setProducttabledata([]);
      toast.error("Failed to fetch product");
    } finally {
      setIsLoading(false);
    }
  };

  const addcategory = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/product_category.php`);
      if (response.data && response.data.data) {
        const categoriesMap = {};

        response.data.data.forEach((item) => {
          if (!item.Category) return;

          if (!categoriesMap[item.Category]) {
            categoriesMap[item.Category] = new Set();
          }

          if (item.SubCategory && typeof item.SubCategory === "string") {
            item.SubCategory.split(",")
              .map((subCat) => subCat.trim())
              .filter((subCat) => subCat.length > 0)
              .forEach((subCat) => {
                categoriesMap[item.Category].add(subCat);
              });
          }
        });

        const transformedData = Object.keys(categoriesMap).map((category) => ({
          Category: category,
          SubCategories: Array.from(categoriesMap[category]),
        }));

        setCategorytabledata(transformedData);
      } else {
        setCategorytabledata([]);
      }
    } catch (error) {
      console.log("add category is error", error);
      setCategorytabledata([]);
    }
  };

  const validateForm = (data) => {
    const newErrors = {
      Category: !data.Category ? "Category is required" : "",
      Subcategory: !data.Subcategory ? "Subcategory is required" : "",

    };
    return newErrors;
  };

  const handleProductSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm(productData);
    setErrors(formErrors);

    if (Object.values(formErrors).some((error) => error !== "")) {
      return;
    }

    try {
      setIsLoading(true);
      const formdata = {
        HSN_code: productData.HSN_code,
        Category: productData.Category,
        Subcategory: productData.Subcategory,
        brand_name: productData.brand_name || "",
        type: productData.type,
        tyre_size: productData.tyre_size,
        status: productData.status,
      };

      await axios.post(`${ApiUrl}/product_data.php`, formdata);
      toast.success("Product added successfully!");
      setProductData({
        HSN_code: "",
        Category: "",
        Subcategory: "",
        brand_name: "",
        type: "",
        tyre_size: "",
        status: "Active",
      });

      fetchdata();
      setShowModal(false);
    } catch (error) {
      console.log("Post data is defind", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Update state and functions
  const [updateModal, setUpdatemodal] = useState(false);
  const [updatedata, setUpdatedata] = useState({
    HSN_code: "",
    Category: "",
    Subcategory: "",
    brand_name: "",
    type: "",
    tyre_size: "",
    status: "Active",
  });
  const [updateid, setUpdateid] = useState();

  const closeUpdateModal = () => {
    setUpdatemodal(false);
    setUpdateErrors({
      Category: "",
      Subcategory: "",
    });
  };

  const handleupdate = (id, data) => {
    setUpdatemodal(true);
    setUpdateid(id);
    setUpdatedata({
      HSN_code: data.HSN_code,
      Category: data.Category,
      Subcategory: data.Subcategory,
      brand_name: data.brand_name,
      type: data.type,
      tyre_size: data.tyre_size,
      status: data.status,
    });
  };

  const validateUpdateForm = (data) => {
    const newErrors = {
      Category: !data.Category ? "Category is required" : "",
      Subcategory: !data.Subcategory ? "Subcategory is required" : "",
    };
    return newErrors;
  };

  const update = async (e) => {
    e.preventDefault();

    const formErrors = validateUpdateForm(updatedata);
    setUpdateErrors(formErrors);

    if (Object.values(formErrors).some((error) => error !== "")) {
      return;
    }

    try {
      setIsLoading(true);
      const formdata = {
        HSN_code: updatedata.HSN_code,
        Category: updatedata.Category,
        Subcategory: updatedata.Subcategory,
        brand_name: updatedata.brand_name,
        type: updatedata.type,
        tyre_size: updatedata.tyre_size,
        status: updatedata.status,
      };

      await axios.put(`${ApiUrl}/product_data.php/${updateid}`, formdata);
      toast.success("Product updated successfully!");

      setUpdatemodal(false);
      fetchdata();
    } catch (error) {
      console.log("update data error", error.message);
      toast.error("update data error");
    } finally {
      setIsLoading(false);
    }
  };

  // Delete state and functions
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");

  const handleOpenModal = (id, HSN_code) => {
    setdeleteid(id);
    setdeletename(HSN_code);
    setDeleteShowModals(true);
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      await axios.delete(`${ApiUrl}/product_data.php/${getdeleteid}`);
      toast.success(`Product ${getdeletename} deleted successfully!`);

      setDeleteShowModals(false);
      fetchdata();
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error("Error deleting data");
    } finally {
      setIsLoading(false);
    }
  };

  // Search and pagination
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const filteredProducts = producttabledata.filter((product) =>
    Object.values(product)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentProducts = filteredProducts.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <div className="bg-white font-sans">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
        />
        {/* Header */}
        <div className="p-3 p-md-4 bg-white">
          <div className="row align-items-center gy-3">
            <div className="col-12 col-sm-6 col-md-6 d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2">
              <h2 className="m-0 fs-5 fw-semibold text-dark">Products</h2>
              {(privileges === "Admin" ||
                privileges === "Staff" ||
                privileges === "Manager") && (
                <button
                  className="btn btn-danger d-flex align-items-center gap-2"
                  onClick={openModal}
                  disabled={isLoading}
                >
                  <Plus size={18} /> Add Product
                </button>
              )}
            </div>

            <div className="col-12 col-sm-6 col-md-6 text-start text-md-end d-flex justify-content-start justify-content-md-end gap-2">
          
                <button
                  onClick={() => navigate("/Productcategory")}
                  className="btn btn-success d-flex align-items-center gap-2"
                  disabled={isLoading}
                >
                  <Plus size={18} /> Add Category
                </button>
             
            </div>
          </div>
        </div>

        {/* Main Card Container */}
        <div className="card mx-3 mx-md-4 mb-5 border">
          {/* Controls Row */}
          <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
            {/* Show All Dropdown */}
            <div
              className="d-flex align-items-center gap-2"
              style={{ height: "36px", width: "120px" }}
            >
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ height: "28px", width: "14px" }}
              >
                <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                  <rect x="1" y="1" width="3" height="3" fill="#666" />
                  <rect x="1" y="5" width="3" height="3" fill="#666" />
                  <rect x="1" y="9" width="3" height="2" fill="#666" />
                  <rect x="5" y="1" width="6" height="1" fill="#666" />
                  <rect x="5" y="3" width="6" height="1" fill="#666" />
                  <rect x="5" y="5" width="6" height="1" fill="#666" />
                  <rect x="5" y="7" width="6" height="1" fill="#666" />
                  <rect x="5" y="9" width="6" height="1" fill="#666" />
                </svg>
              </div>
              <select
                className="border-0 bg-transparent text-dark form-select form-select-sm"
                style={{
                  boxShadow: "none",
                  outline: "none",
                  lineHeight: "1.1",
                  height: "28px",
                  cursor: "pointer",
                  width: "80px",
                  paddingTop: "0",
                  paddingBottom: "0",
                }}
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                disabled={isLoading}
              >
                <option value="5">Show 5</option>
                <option value="10">Show 10</option>
                <option value="25">Show 25</option>
              </select>
            </div>

            {/* Search */}
            <div className="position-relative" style={{ width: "280px" }}>
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-100 ps-3 pe-5 py-2 border rounded form-control"
                disabled={isLoading}
              />
              <Search
                size={18}
                className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
                style={{ pointerEvents: "none" }}
              />
            </div>
          </div>

          {/* Table Container */}
          <div className="card-body p-0">
            {/* Loading Indicator */}
            {isLoading && (
              <div className="text-center p-4">
                <div className="spinner-border text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}

            {/* Table */}
            {!isLoading && (
              <div className="table-responsive">
                <table className="table table-hover mb-0 text-center">
                  <thead>
                    <tr>
                      <th
                        className="p-3 fw-semibold small"
                        style={{ backgroundColor: "#d3d3d3" }}
                      >
                        S.No
                      </th>
                      <th
                        className="p-3 fw-semibold small"
                        style={{ backgroundColor: "#d3d3d3" }}
                      >
                        HSN Code
                      </th>
                      <th
                        className="p-3 fw-semibold small"
                        style={{ backgroundColor: "#d3d3d3" }}
                      >
                        Category
                      </th>
                      <th
                        className="p-3 fw-semibold small"
                        style={{ backgroundColor: "#d3d3d3" }}
                      >
                        Subcategory
                      </th>
                      <th
                        className="p-3 fw-semibold small"
                        style={{ backgroundColor: "#d3d3d3" }}
                      >
                        Brand Name
                      </th>
                      <th
                        className="p-3 fw-semibold small"
                        style={{ backgroundColor: "#d3d3d3" }}
                      >
                        Type
                      </th>
                      <th
                        className="p-3 fw-semibold small"
                        style={{ backgroundColor: "#d3d3d3" }}
                      >
                        Tyre Size
                      </th>
                      <th
                        className="p-3 fw-semibold small"
                        style={{ backgroundColor: "#d3d3d3" }}
                      >
                        Status
                      </th>
                      <th
                        className="p-3 fw-semibold small"
                        style={{ backgroundColor: "#d3d3d3" }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentProducts.length > 0 ? (
                      currentProducts.map((product, index) => (
                        <tr key={index} style={{ fontSize: "14px" }}>
                          <td>{startIndex + index + 1}</td>
                          <td>{product.HSN_code}</td>
                          <td>{product.Category}</td>
                          <td>{product.Subcategory}</td>
                          <td>{product.brand_name}</td>
                          <td>{product.type}</td>
                          <td>{product.tyre_size}</td>
                          <td className="small">
                            <span
                              className={`d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill small fw-medium ${
                                product.status === "Active"
                                  ? "bg-success bg-opacity-10 text-success"
                                  : "bg-danger bg-opacity-10 text-danger"
                              }`}
                            >
                              {product.status}
                            </span>
                          </td>
                          <td className="small">
                            <div className="d-flex justify-content-center">
                              {privileges === "Admin" && (
                                <button
                                  onClick={() =>
                                    handleOpenModal(
                                      product.id,
                                      product.HSN_code
                                    )
                                  }
                                  className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                                  disabled={isLoading}
                                >
                                  <Trash2 size={16} />
                                </button>
                              )}
                              {(privileges === "Admin" ||
                                privileges === "Manager") && (
                                <button
                                  onClick={() =>
                                    handleupdate(product.id, product)
                                  }
                                  className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                                  disabled={isLoading}
                                >
                                  <Edit2 size={16} />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} className="text-center p-5">
                          {producttabledata.length === 0
                            ? "No data available."
                            : "No matching products found."}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* Pagination */}
            {!isLoading && itemsPerPage < filteredProducts.length && (
              <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1 || isLoading}
                  className={`btn btn-sm d-flex align-items-center gap-2 ${
                    currentPage === 1
                      ? "bg-light text-muted"
                      : "bg-white text-dark"
                  }`}
                >
                  <FaChevronLeft size={14} />
                  <span className="ms-1 d-none d-md-inline">Previous</span>
                </button>

                <div className="d-flex gap-1">
                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (currentPage <= 3) {
                      pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = currentPage - 2 + i;
                    }

                    return (
                      <button
                        key={pageNum}
                        onClick={() => setCurrentPage(pageNum)}
                        disabled={isLoading}
                        className={`btn btn-sm ${
                          pageNum === currentPage
                            ? "bg-danger bg-opacity-10 text-danger"
                            : "bg-white text-dark"
                        }`}
                        style={{ width: "32px", height: "32px" }}
                      >
                        {pageNum}
                      </button>
                    );
                  })}
                  {totalPages > 5 && currentPage < totalPages - 2 && (
                    <span className="px-2 py-1">...</span>
                  )}
                  {totalPages > 5 && currentPage < totalPages - 2 && (
                    <button
                      onClick={() => setCurrentPage(totalPages)}
                      disabled={isLoading}
                      className={`btn btn-sm ${
                        totalPages === currentPage
                          ? "bg-danger bg-opacity-10 text-danger"
                          : "bg-white text-dark"
                      }`}
                      style={{ width: "32px", height: "32px" }}
                    >
                      {totalPages}
                    </button>
                  )}
                </div>

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages || isLoading}
                  className={`btn btn-sm d-flex align-items-center gap-2 ${
                    currentPage === totalPages
                      ? "bg-light text-muted"
                      : "bg-white text-dark"
                  }`}
                >
                  <span className="ms-1 d-none d-md-inline">Next</span>
                  <FaChevronRight size={14} />
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Add Product Modal */}
        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          style={{
            display: showModal ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content rounded"
              style={{ backgroundColor: "rgb(255, 240, 245)" }}
            >
              <div className="modal-header bg-pink-light border-bottom-0">
                <h5 className="modal-title m-0 fw-semibold">Add Product</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                  disabled={isLoading}
                ></button>
              </div>

              <div className="modal-body bg-pink-light">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      HSN Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={productData.HSN_code}
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          HSN_code: e.target.value,
                        })
                      }
                      placeholder="Enter the HSN Code"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Category <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-select-sm ${
                        errors.Category ? "is-invalid" : ""
                      }`}
                      value={productData.Category}
                      onChange={(e) => {
                        setProductData({
                          ...productData,
                          Category: e.target.value,
                          Subcategory: "",
                        });
                        setErrors({ ...errors, Category: "" });
                      }}
                    >
                      <option value="" disabled>
                        Select Category
                      </option>
                      {categorytabledata &&
                        categorytabledata.map((category, index) => (
                          <option key={index} value={category.Category}>
                            {category.Category}
                          </option>
                        ))}
                    </select>
                    {errors.Category && (
                      <div className="text-danger small mt-1">
                        {errors.Category}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Subcategory <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-select-sm ${
                        errors.Subcategory ? "is-invalid" : ""
                      }`}
                      value={productData.Subcategory}
                      onChange={(e) => {
                        setProductData({
                          ...productData,
                          Subcategory: e.target.value,
                        });
                        setErrors({ ...errors, Subcategory: "" });
                      }}
                      disabled={!productData.Category}
                    >
                      <option value="" disabled>
                        Select Subcategory
                      </option>
                      {productData.Category &&
                        categorytabledata &&
                        categorytabledata
                          .find((cat) => cat.Category === productData.Category)
                          ?.SubCategories?.map((subcat, index) => (
                            <option key={index} value={subcat}>
                              {subcat}
                            </option>
                          ))}
                    </select>
                    {errors.Subcategory && (
                      <div className="text-danger small mt-1">
                        {errors.Subcategory}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Brand Name
                    </label>
                    <select
                      className={`form-control form-control-sm ${
                        errors.brand_name ? "is-invalid" : ""
                      }`}
                      value={productData.brand_name}
                      onChange={(e) => {
                        setProductData({
                          ...productData,
                          brand_name: e.target.value,
                        });
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          brand_name: "",
                        }));
                      }}
                    >
                      <option value="">Select Brand Name</option>
                      <option value="MRF">MRF</option>
                      <option value="CEAT">CEAT</option>
                      <option value="Apollo">Apollo</option>
                      <option value="JK Tyre">JK Tyre</option>
                      <option value="Bridgestone">Bridgestone</option>
                    </select>
                    {errors.brand_name && (
                      <div className="text-danger small mt-1">
                        {errors.brand_name}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">Type</label>
                    <select
                      className="form-select form-select-sm"
                      value={productData.type}
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          type: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Type</option>
                      <option value="Radial">Radial</option>
                      <option value="Bias">Bias</option>
                      <option value="Tubeless">Tubeless</option>
                      <option value="Tube Type">Tube Type</option>
                      <option value="Solid">Solid</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Tyre Size
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={productData.tyre_size}
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          tyre_size: e.target.value,
                        })
                      }
                      placeholder="Enter Tyre Size"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Product Status
                    </label>
                    <select
                      className="form-select form-select-sm"
                      value={productData.status}
                      onChange={(e) =>
                        setProductData({
                          ...productData,
                          status: e.target.value,
                        })
                      }
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="modal-footer border-top-0">
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={closeModal}
                  disabled={isLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={handleProductSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? "Adding..." : "Confirm"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Product Modal */}
        <div
          className={`modal fade ${updateModal ? "show" : ""}`}
          style={{
            display: updateModal ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content rounded"
              style={{ backgroundColor: "rgb(255, 240, 245)" }}
            >
              <div className="modal-header bg-pink-light border-bottom-0">
                <h5 className="modal-title m-0 fw-semibold">Edit Product</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeUpdateModal}
                  disabled={isLoading}
                ></button>
              </div>

              <div className="modal-body bg-pink-light">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      HSN Code <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={updatedata.HSN_code}
                      readOnly
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Category <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-select-sm ${
                        updateErrors.Category ? "is-invalid" : ""
                      }`}
                      value={updatedata.Category}
                      onChange={(e) => {
                        setUpdatedata({
                          ...updatedata,
                          Category: e.target.value,
                          Subcategory: "",
                        });
                        setUpdateErrors({ ...updateErrors, Category: "" });
                      }}
                    >
                      <option value="">Select Category</option>
                      {categorytabledata.map((category, index) => (
                        <option key={index} value={category.Category}>
                          {category.Category}
                        </option>
                      ))}
                    </select>
                    {updateErrors.Category && (
                      <div className="text-danger small mt-1">
                        {updateErrors.Category}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Subcategory <span className="text-danger">*</span>
                    </label>
                    <select
                      className={`form-select form-select-sm ${
                        updateErrors.Subcategory ? "is-invalid" : ""
                      }`}
                      value={updatedata.Subcategory}
                      onChange={(e) => {
                        setUpdatedata({
                          ...updatedata,
                          Subcategory: e.target.value,
                        });
                        setUpdateErrors({ ...updateErrors, Subcategory: "" });
                      }}
                      disabled={!updatedata.Category}
                    >
                      <option value="">Select Subcategory</option>
                      {updatedata.Category &&
                        categorytabledata
                          .find((cat) => cat.Category === updatedata.Category)
                          ?.SubCategories?.map((subcat, index) => (
                            <option key={index} value={subcat}>
                              {subcat}
                            </option>
                          ))}
                    </select>
                    {updateErrors.Subcategory && (
                      <div className="text-danger small mt-1">
                        {updateErrors.Subcategory}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Brand Name
                    </label>
                    <select
                      className="form-select form-select-sm"
                      value={updatedata.brand_name}
                      onChange={(e) =>
                        setUpdatedata({
                          ...updatedata,
                          brand_name: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Brand Name</option>
                      <option value="MRF">MRF</option>
                      <option value="CEAT">CEAT</option>
                      <option value="Apollo">Apollo</option>
                      <option value="JK Tyre">JK Tyre</option>
                      <option value="Bridgestone">Bridgestone</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">Type</label>
                    <select
                      className="form-select form-select-sm"
                      value={updatedata.type}
                      onChange={(e) =>
                        setUpdatedata({
                          ...updatedata,
                          type: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Type</option>
                      <option value="Radial">Radial</option>
                      <option value="Bias">Bias</option>
                      <option value="Tubeless">Tubeless</option>
                      <option value="Tube Type">Tube Type</option>
                      <option value="Solid">Solid</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Tyre Size
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={updatedata.tyre_size}
                      onChange={(e) =>
                        setUpdatedata({
                          ...updatedata,
                          tyre_size: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      Product Status
                    </label>
                    <select
                      className="form-select form-select-sm"
                      value={updatedata.status}
                      onChange={(e) =>
                        setUpdatedata({
                          ...updatedata,
                          status: e.target.value,
                        })
                      }
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="modal-footer border-top-0">
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={closeUpdateModal}
                  disabled={isLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={update}
                  disabled={isLoading}
                >
                  {isLoading ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Delete Confirmation Modal */}
        <div
          className={`modal fade ${deleteShowModals ? "show" : ""}`}
          style={{
            display: deleteShowModals ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered modal-confirm">
            <div className="modal-content">
              <div className="modal-body text-center">
                <div className="d-flex justify-content-center mb-3">
                  <div
                    className="icon-box bg-light rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                  </div>
                </div>
                <h4 className="modal-title mb-3">Are you sure?</h4>
                <h6 className="mb-4">
                  Do you really want to delete this product{" "}
                  <span className="text-primary">({getdeletename})</span>?
                </h6>
                <div className="d-flex btn-group">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm flex-grow-1"
                    onClick={handleCloseModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm flex-grow-1 mx-2"
                    onClick={handleDelete}
                    disabled={isLoading}
                  >
                    {isLoading ? "Deleting..." : "Delete"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductsTable;